/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedTalent } from './AbbreviatedTalent';

export interface AffiliateAnnouncementRequest {

    id?: string;

    title?: string;

    date?: string;

    /**
     * Image for the announcement (optional)
     */
    image?: string;

    text?: string;

    url?: string;

    visible?: boolean;

    author?: ApiAbbreviatedTalent;

}

@Model('AffiliateAnnouncement')
export class ApiAffiliateAnnouncement extends BaseModel implements AffiliateAnnouncementRequest {

    
    
    id: string;

    
    
    title: string;

    
    
    date: string;

    /**
     * Image for the announcement (optional)
     */
    
    
    image: string;

    
    
    text: string;

    
    
    url: string;

    
    
    visible: boolean;

    @Type('ApiAbbreviatedTalent')
    @Expand()
    author: ApiAbbreviatedTalent;

}
